/* 📦 LIBS */
import { Trans } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, CloseIcon } from "../../Components";

/* 📁 ASSETS*/
import { Ajuda } from "../../Assets/icons";

/* 🎨 STYLES */
import { PopoverContainer } from "./styles";
import { HelpIcon } from "../styles";

const Popover = ({ stepNumber, title, text, onClose, children }) => {
    return(
        <PopoverContainer>
            <Button color={"white-green"} onClick={() => onClose()} icon={<CloseIcon fill={"#006560"}/>} padding={"0"} position={"absolute"} radius={"50%"} height={"36px"} width={"36px"}/>
            <div className="header">
                <h2>
                <span>{stepNumber}</span>
                {title}
                </h2>
                <Button color={"transparent"} icon={<HelpIcon src={Ajuda} />} padding={"8px 10px"} radius={"3px"} width={"44px"}/>
            </div>
            <p>
                <Trans i18nKey={text} components={{ strong: <strong /> }} />
            </p>
            <div className="container">
                {children ? children : <></>}
            </div>
        </PopoverContainer>
    );
};

export default Popover;